import { FormatterService } from "@/domain/services";

export class CurrencyFormatter implements FormatterService {
  format(value: number): string {
    if (!value) return "R$ 0,00";
    return value.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  }

  reverse(value: string, int: boolean = false): number {
    if (!value) return 0;
    const number = Number(
      value.replace("R$", "").replaceAll(".", "").replace(",", ".").trim()
    );

    if (int) return parseInt(`${number}`);

    return number;
  }
}
